import { Outlet } from 'react-router-dom';
import ExtensionRoute from '../../modules/core/public/ExtensionRoute';

export default function CatalogRoutes() {
  return (
    <ExtensionRoute extensionId="catalog">
      <Outlet />
    </ExtensionRoute>
  );
}
